(function () {
  /**
   * Product Template Script
   * ------------------------------------------------------------------------------
   * A file that contains code highly coupled to the Product template.
   *
   * @namespace product
   * @file template.product.js
   *
   */

  // import '../sections/product-reviews.js';
  // import '../../styles/sections/product-reviews.scss';
  const VARIANT_CHANGE = new CustomEvent("variantChange", { "detail": "The variant has been updated."});
  const json = JSON.parse(document.querySelector(".js-product-json").innerHTML);
  const { selectedOrFirstAvailableVariant, product } = json;
  const RETEXTION_APP_ID = "5859381";
  const BOX_ID = document.querySelector(`.rtx-subscription`).dataset.label;
  let RETEXTION_ROOT = document.querySelector(`[${BOX_ID}]`);
  let RETEXTION_FORM =
    RETEXTION_ROOT.closest('form[action="/cart/add"]') ||
    root.closest("form") ||
    document.querySelector('form[action="/cart/add"]') ||
    document.documentElement;
  window.theme = window.theme || {};
  theme.product = theme.product || {
    boxId: document.querySelector(`.rtx-subscription`).dataset.label,
    data: product,
    variantId: selectedOrFirstAvailableVariant,
    variant: product.variants.filter(
      (v) => v.id === selectedOrFirstAvailableVariant,
    )[0],
    root: RETEXTION_ROOT,
    form: RETEXTION_FORM,
    subscriptionBox: RETEXTION_ROOT.querySelector(
      "[data-retextion-subscription-box]",
    ),
    sellingPlanSelector: RETEXTION_ROOT.querySelector('[name="selling_plan"]'),
    quantitySelector: RETEXTION_FORM.querySelector('[name="quantity"]'),
    purchaseType: RETEXTION_FORM.querySelectorAll('[name="purchaseType"]'),
    variantSelectors: RETEXTION_FORM.querySelectorAll('[name="id"]'),
    labelOneTime: RETEXTION_FORM.querySelector('[for="purchaseTypeOneTime"]'),
    labelSubscription: RETEXTION_FORM.querySelector(
      '[for="purchaseTypeSubscription"]',
    ),
    cachedSellingPlanId: RETEXTION_ROOT.querySelector('[name="selling_plan"]')
      ? RETEXTION_ROOT.querySelector('[name="selling_plan"]').value
      : undefined,
    onetimeButton: document.querySelector(".js-add-to-cart--onetime"),
    subscribeButton: document.querySelector(".js-add-to-cart--subscribe"),
    media: {
      thumbnails: document.querySelectorAll("li.product-thumbnail"),
      images: document.querySelectorAll("div.product-image"),
    },

    init: () => {
      theme.product.createStickyPurchase();
      theme.product.updateStickyPurchase(theme.product.variant);
      theme.product.updateSubscriptionUI(theme.product.variant);
      theme.product.updateBadgeUI(theme.product.variant);
      theme.product.setValidOptionSelectors(theme.product.variant);
      theme.product.updateMainButtonPrice();

      //init video
      theme.waitForElement("body.swiper--enabled").then(() => {
        theme.product.media.thumbnailSlider = new theme.vendor.Swiper(
          ".product-thumbnails",
          {
            slidesPerView: "auto",
            spaceBetween: 6,
            centeredSlides: false,
            loop: false,
            observer: true,
            slideToClickedSlide: false,
            on: {
              init: function () {
                // Show thumbnails when slider is initialized
                const thumbnailsContainer = document.querySelector(
                  ".product-thumbnails",
                );
                if (thumbnailsContainer) {
                  thumbnailsContainer.style.opacity = "1";
                }
              },
            },
          },
        );

        theme.product.media.imageSlider = new theme.vendor.Swiper(
          ".product-images",
          {
            speed: 400,
            slidesPerView: 1,
            centeredSlides: true,
            loop: false,
            observer: true,
            thumbs: {
              swiper: theme.product.media.thumbnailSlider,
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
            on: {
              slideChange: function (e) {
                const slide = e.slides[e.activeIndex];
                if (!slide) return;
                const muxPlayer = slide.querySelector('mux-player');
                if (muxPlayer) {
                  console.log('>>>>>> muxPlayer', muxPlayer);
                  let awaitMUX = setInterval(function () {
                    if ("undefined" !== typeof MuxPlayerElement) {
                      setTimeout(function () {
                        muxPlayer.play();
                      }, 3000);
                      clearInterval(awaitMUX);
                    } else {
                      setTimeout(function () {
                        clearInterval(awaitMUX);
                      }, 10000);
                    }
                  }, 200);
                }
              },
            },  
          },
        );
      });

      let setBISInterval = setInterval(function () {
        if (document.querySelectorAll(".klaviyo-bis-trigger").length > 0) {
          if (
            document.querySelector("[data-force-bis]") &&
            document.querySelector("[data-force-bis]").dataset.forceBis ===
              "true"
          ) {
            document
              .querySelector(".klaviyo-bis-trigger")
              .classList.remove("hidden");
          }
          clearInterval(setBISInterval);
        } else {
          setTimeout(function () {
            clearInterval(setBISInterval);
          }, 10000);
        }
      }, 100);

      theme.waitForElement("body.swiper--enabled").then(() => {
        if (theme.product.variant.title !== "Default Title") {
          theme.product.setCurrentVariantMedia(theme.product.variant);
        }
      });
      // document.querySelector('.product__accordion:last-child [id^="Details-"]').setAttribute('open', true);
    },
    nodeToString: function (node) {
      return node.outerHTML || new XMLSerializer().serializeToString(node);
    },
    removeEmptyOption: () => {
      const optEmpty =
        theme.product.sellingPlanSelector.querySelectorAll('[value=""]');
      optEmpty.forEach((e) => e.remove());
    },
    addEmptyOption: () => {
      let optEmpty =
        theme.product.sellingPlanSelector.querySelector('[value=""]');
      if (optEmpty) return;
      optEmpty = document.createElement("option");
      optEmpty.value = "";
      optEmpty.textContent = "One Time";
      theme.product.sellingPlanSelector.appendChild(optEmpty);
    },
    hideSubscriptionBox: () => {
      theme.product.cachedSellingPlanId =
        theme.product.sellingPlanSelector.value;
      theme.product.subscriptionBox.classList.remove("is-visible");
      theme.product.addEmptyOption();
      theme.product.sellingPlanSelector.value = "";
      theme.product.updateSellingPlan();
      if (theme.product.labelOneTime)
        theme.product.labelOneTime.classList.add("is-selected");
      if (theme.product.labelSubscription)
        theme.product.labelSubscription.classList.remove("is-selected");
    },
    showSubscriptionBox: () => {
      theme.product.subscriptionBox.classList.add("is-visible");
      theme.product.sellingPlanSelector.value =
        theme.product.cachedSellingPlanId;
      theme.product.removeEmptyOption();
      theme.product.updateSellingPlan();
      if (theme.product.labelOneTime)
        theme.product.labelOneTime.classList.remove("is-selected");
      if (theme.product.labelSubscription)
        theme.product.labelSubscription.classList.add("is-selected");
    },
    isSubscriptionBoxVisible: () => {
      return theme.product.subscriptionBox.classList.contains("is-visible");
    },
    getSellingPlanId: () => {
      return parseInt(theme.product.sellingPlanSelector.value);
    },
    setSellingPlan: (sellingPlan) => {
      sellingPlan =
        sellingPlan && sellingPlan.id ? sellingPlan.id : sellingPlan;
      theme.product.sellingPlanSelector.value = sellingPlan.toString();
    },
    getFormData: () => {
      const formData = new FormData(theme.product.form);
      return Array.from(formData.entries());
    },

    updateSellingPlan: () => {
      const variant = theme.product.data.variants.find(
        (v) => v.id == theme.product.variantId,
      );
      theme.product.updatePlansForVariant(variant);
      const discountLabels = theme.product.root.querySelectorAll(
        "[data-rtx-subscription-price]",
      );
      const fullPriceLabels = theme.product.root.querySelectorAll(
        "[data-rtx-onetime-price]",
      );
      const titlePrice = document.querySelector(".product-main [data-price]");
      const titlePriceCompare = document.querySelector(
        ".product-main [data-compare-price]",
      );
      const discountLabelInfo = theme.product.root.querySelectorAll(
        "[data-rtx-subscription-discount]",
      );
      const sellingPlanId = theme.product.isSubscriptionBoxVisible()
        ? theme.product.getSellingPlanId()
        : undefined;
      const sellingPlanAllocation = sellingPlanId
        ? variant.selling_plan_allocations.find(
            (spa) => spa.selling_plan_id == sellingPlanId,
          )
        : undefined;
      const firstSellingPlanAllocation =
        variant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id == theme.product.getSellingPlanId(),
        ) || variant.selling_plan_allocations.find((spa) => spa);
      let strDiscount;
      let strDiscountPercentage;
      if (
        firstSellingPlanAllocation &&
        firstSellingPlanAllocation.price != variant.price
      ) {
        let percentage = Math.round(
          (1.0 - firstSellingPlanAllocation.price / variant.price) * 100,
        );
        if (percentage != 0) {
          strDiscountPercentage = `${percentage.toFixed(0)}%`;
          strDiscount =
            `${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`.replace(
              ".00",
              "",
            );
        } else {
          strDiscountPercentage = "";
          strDiscount =
            `${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`.replace(
              ".00",
              "",
            );
        }
      } else {
        strDiscountPercentage = "";
        strDiscount = "";
      }
      let strFullPrice =
        `${window.retextionApi.formatMoney(variant.price)}`.replace(".00", "");

      discountLabels.forEach((dl) => (dl.textContent = strDiscount));
      discountLabelInfo.forEach(
        (dl) => (dl.textContent = strDiscountPercentage),
      );
      fullPriceLabels.forEach((fp) => (fp.textContent = strFullPrice));
      if (titlePrice) {
        titlePrice.textContent = theme.product.isSubscriptionBoxVisible()
          ? strDiscount
          : strFullPrice;
        // titlePriceCompare.textContent = strFullPrice;
        // titlePriceCompare.style.display = strDiscount != strFullPrice ? 'block' : 'none';
      }

      if (theme.product.isSubscriptionBoxVisible()) {
        window.retextionApi.sellingPlanPushHistory({
          sellingPlan: sellingPlanId,
        });
      }
    },
    setCurrentVariantLabel: (variant = theme.product.variant) => {
      if (
        document.querySelector("[data-product-option-1-value]") &&
        variant.option1
      ) {
        document.querySelector("[data-product-option-1-value]").innerHTML =
          variant.option1;
      }
      if (
        document.querySelector("[data-product-option-2-value]") &&
        variant.option2
      ) {
        document.querySelector("[data-product-option-2-value]").innerHTML =
          variant.option2;
      }
      if (
        document.querySelector("[data-product-option-3-value]") &&
        variant.option3
      ) {
        document.querySelector("[data-product-option-3-value]").innerHTML =
          variant.option3;
      }
    },
    updateVariantSelector: (variantId = theme.product.variantId) => {
      document.querySelector('[name="id"]').value = variantId;
    },
    updateStockStatus: (variant = theme.product.variant) => {
      document.querySelectorAll(".js-add-to-cart").forEach(function (button) {
        if (variant.available && variant.inventory_quantity > 0) {
          button.dataset.availability = "available";
          button.disabled = false;
        }
        if (
          variant.available &&
          variant.inventory_quantity <= 0 &&
          variant.inventory_policy == "continue"
        ) {
          button.dataset.availability = "preorder";
          button.disabled = false;
        }
        if (
          !variant.available &&
          variant.inventory_quantity <= 0 &&
          variant.inventory_policy != "continue"
        ) {
          button.dataset.availability = "outofstock";
          button.disabled = true;
        }
        if (!theme.product.data.available) {
          button.dataset.availability = "unavailable";
          button.disabled = true;
        }
      });
    },
    updateCurrentVariant: () => {
      let newVariant;

      for (let i = 0; i < theme.product.data.variants.length; i++) {
        let variant = theme.product.data.variants[i];
        if (document.querySelector("[data-product-option-1]")) {
          if (
            document.querySelector("[data-product-option-1] input:checked")
              .value !== variant.option1
          ) {
            console.log(
              "1 Selected Option1",
              document.querySelector("[data-product-option-1] input:checked")
                .value,
            );
            continue;
          }
        }
        if (document.querySelector("[data-product-option-2]")) {
          if (
            document.querySelector("[data-product-option-2] input:checked")
              .value !== variant.option2
          ) {
            console.log(
              "2 Selected Option2",
              document.querySelector("[data-product-option-2] input:checked")
                .value,
            );
            continue;
          }
        }
        if (document.querySelector("[data-product-option-3]")) {
          if (
            document.querySelector("[data-product-option-3] input:checked")
              .value !== variant.option3
          ) {
            console.log(
              "3 Selected Option3",
              document.querySelector("[data-product-option-3] input:checked")
                .value,
            );
            continue;
          }
        }
        newVariant = variant;
      }

      // Find a variant that matches the first variant option when a perfectly matching variant is not found
      if (!newVariant) {
        let replacementVariant;
        theme.product.data.variants.forEach((variant) => {
          if (
            variant.option1 ===
            document.querySelector("[data-product-option-1] input:checked")
              .value
          ) {
            replacementVariant = variant;
          }
        });
        let inValidSelectors =
          theme.product.getInvalidOptionSelectors(replacementVariant);

        if (inValidSelectors.hideOptions2.length > 0) {
          if (
            document.querySelector(
              `[data-product-option-2] [data-option-title]`,
            )
          ) {
            document
              .querySelector(
                `[data-product-option-2] .radio:not([data-option-title="${inValidSelectors.hideOptions2[0]}"])`,
              )
              .click();
          }
        }
        if (inValidSelectors.hideOptions3.length > 0) {
          if (
            document.querySelector(
              `[data-product-option-3] [data-option-title]`,
            )
          ) {
            document
              .querySelector(
                `[data-product-option-3] .radio:not([data-option-title="${inValidSelectors.hideOptions3[0]}"])`,
              )
              .click();
          }
        }
      }

      if (newVariant) {
        theme.product.variant = newVariant;
        theme.product.variantId = newVariant.id;
        document.body.dispatchEvent(VARIANT_CHANGE);
      }
    },
    disableSubscriptionUI: () => {
      document
        .querySelectorAll(".s-add-to-cart--subscribe")
        .forEach(function (button) {
          button.dataset.availability = "unavailable";
          button.disabled = true;
        });
      document
        .querySelectorAll(".product-purchase__benefits")
        .forEach(function (benefits) {
          benefits.style.height = `${document.querySelector(".product-purchase__benefits").offsetHeight}px`;
          benefits.classList.add("benefits--hidden");
        });
    },
    enableSubscriptionUI: () => {
      document
        .querySelectorAll(".s-add-to-cart--subscribe")
        .forEach(function (button) {
          button.dataset.availability = "available";
          button.disabled = false;
        });
      document
        .querySelectorAll(".product-purchase__benefits")
        .forEach(function (benefits) {
          //benefits.style.height = ``;
          benefits.classList.remove("benefits--hidden");
        });
    },
    setCurrentVariantMedia: function (variant) {
      theme.product.media.imageSlider.removeAllSlides();

      // Collect and sort matched slides by priority
      let matchedSlides = [];
      theme.product.media.images.forEach(function (slide, index) {
        let variantName = slide.dataset.imageAlt
          ? slide.dataset.imageAlt.split("#").slice(-1)[0]
          : slide.dataset.imageAlt;
        variantName =
          "undefined" !== typeof slide.dataset.imageAlt &&
          slide.dataset.imageAlt.includes("_")
            ? slide.dataset.imageAlt.split("_").slice(-1)[0]
            : variantName;

        // console.log('>>>>>> url', slide.querySelector('img')?.src);
        // console.log('alt', slide.dataset.imageAlt);
        // console.log('variantName', variantName);
        // console.log('theme.product.variant.title', theme.product.variant.title);
        // console.log('rules:');
        // console.log('1. slide.dataset.imageVariantId && slide.dataset.imageVariantId.includes(variant.id)', slide.dataset.imageVariantId && slide.dataset.imageVariantId.includes(variant.id));
        // console.log('2. theme.product.variant.title.includes(variantName)', theme.product.variant.title.includes(variantName));
        // console.log('3. slide.classList.contains("product-video")', slide.classList.contains('product-video'));
        // console.log('4. slide.dataset.imageAlt && !slide.dataset.imageAlt.includes("#")', slide.dataset.imageAlt && !slide.dataset.imageAlt.includes('#'));

        let priority = 0;
        let matched = false;

        // Priority 1: variant id matched
        if (
          slide.dataset.imageVariantId &&
          slide.dataset.imageVariantId.includes(variant.id)
        ) {
          priority = 1;
          matched = true;
        }
        // Priority 2: variantName matched
        else if (theme.product.variant.title.includes(variantName)) {
          priority = 2;
          matched = true;
        }
        // Priority 3: video
        else if (slide.classList.contains("product-video")) {
          priority = 3;
          matched = true;
        }
        // Priority 4: hasn't # in alt
        else if (
          slide.dataset.imageAlt &&
          !slide.dataset.imageAlt.includes("#")
        ) {
          priority = 4;
          matched = true;
        }

        if (matched) {
          matchedSlides.push({ slide, index, priority });
          // console.log(`++++++ matched with priority ${priority}!`);
        } else {
          // console.log('------ not matched!');
        }
        
      });

      // Sort by priority and add to slider
      matchedSlides.sort((a, b) => a.priority - b.priority);
      matchedSlides.forEach(function (item) {
        let slideHTML = theme.product.nodeToString(
          theme.product.media.images[item.index],
        );
        slideHTML = slideHTML.replace('"', '"');
        theme.product.media.imageSlider.appendSlide(slideHTML);
      });

      theme.product.media.imageSlider.slideTo(0, 500);

      theme.product.media.thumbnailSlider.removeAllSlides();

      // Collect and sort matched thumbnail slides by priority
      let matchedThumbnails = [];
      theme.product.media.thumbnails.forEach(function (slide, index) {
        let variantName = slide.dataset.imageAlt
          ? slide.dataset.imageAlt.split("#").slice(-1)[0]
          : slide.dataset.imageAlt;
        variantName =
          "undefined" !== typeof slide.dataset.imageAlt &&
          slide.dataset.imageAlt.includes("_")
            ? slide.dataset.imageAlt.split("_").slice(-1)[0]
            : variantName;

        let priority = 0;
        let matched = false;

        // Priority 1: variant id matched
        if (
          slide.dataset.imageVariantId &&
          slide.dataset.imageVariantId.includes(variant.id)
        ) {
          priority = 1;
          matched = true;
        }
        // Priority 2: variantName matched
        else if (theme.product.variant.title.includes(variantName)) {
          priority = 2;
          matched = true;
        }
        // Priority 3: video (thumbnail-video for thumbnails)
        else if (slide.classList.contains("thumbnail-video")) {
          priority = 3;
          matched = true;
        }
        // Priority 4: hasn't # in alt
        else if (
          slide.dataset.imageAlt &&
          !slide.dataset.imageAlt.includes("#")
        ) {
          priority = 4;
          matched = true;
        }

        if (matched) {
          matchedThumbnails.push({ slide, index, priority });
        }
      });

      // Sort by priority and add to thumbnail slider
      matchedThumbnails.sort((a, b) => a.priority - b.priority);
      matchedThumbnails.forEach(function (item) {
        let slideHTML = theme.product.nodeToString(
          theme.product.media.thumbnails[item.index],
        );
        slideHTML = slideHTML.replace('"', '"');
        theme.product.media.thumbnailSlider.appendSlide(slideHTML);
      });

      theme.product.media.thumbnailSlider.slideTo(0, 500);

      // Ensure thumbnails remain visible after media update
      const thumbnailsContainer = document.querySelector(".product-thumbnails");
      if (thumbnailsContainer) {
        thumbnailsContainer.style.opacity = "1";
      }
    },
    createStickyPurchase: () => {
      let standardPurchaseButton = document.querySelector(
        ".product__form-actions .button",
      );
      let stickyPurchaseButton = document.querySelector(
        ".product-sticky-purchase button",
      );

      document.addEventListener(
        "scroll",
        function () {
          const actionButtonValues = document
            .querySelector(".product__form-actions")
            .getBoundingClientRect();
          const trueHeight = actionButtonValues.top + actionButtonValues.height;

          if (
            trueHeight < 0 &&
            window.innerHeight + window.scrollY <=
              document.body.offsetHeight - 400 &&
            window.scrollY > 400
          ) {
            document
              .querySelector("body")
              .classList.add("sticky-purchase--active");
          } else {
            document
              .querySelector("body")
              .classList.remove("sticky-purchase--active");
          }
        },
        {
          capture: true,
          passive: true,
        },
      );

      stickyPurchaseButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();

          if (standardPurchaseButton) {
            standardPurchaseButton.click();
          }
        },
        false,
      );
    },
    updateStickyPurchase: (variant = theme.product.variant) => {
      const mainProductPriceBlock = document.querySelector(
        ".product__form-actions button [data-rtx-onetime-price]",
      );
      const stickyWidgetPriceBlock = document.querySelector(
        ".sticky-product-price",
      );
      const atcButtonPriceBlock = document.querySelector(
        ".product-sticky-purchase [data-rtx-onetime-price]",
      );
      const stickyWidgetTitleEL = document.querySelector(
        "[data-sticky-product]",
      );

      if (stickyWidgetTitleEL) {
        stickyWidgetTitleEL.innerHTML = theme.product.data.title;
      }

      if (mainProductPriceBlock && stickyWidgetPriceBlock) {
        stickyWidgetPriceBlock.innerHTML = mainProductPriceBlock.innerHTML;
      }

      if (atcButtonPriceBlock && mainProductPriceBlock) {
        atcButtonPriceBlock.innerHTML = mainProductPriceBlock.innerHTML;
      }
    },
    updateMainButtonPrice: () => {
      const activeOption = document.querySelector(
        ".rtx-subscription-label.is-selected",
      );
      const mainButton = document.querySelector(
        ".product__form-actions button [data-rtx-onetime-price]",
      );
      const activeOptionInput = activeOption.querySelector(
        ".rtx-subscription-label__inner > input",
      );
      let currentVariantPrice = "";

      if (activeOptionInput.value === "purchaseTypeOneTime") {
        currentVariantPrice = activeOption.querySelector(
          "[data-rtx-onetime-price]",
        ).innerHTML;
      } else {
        currentVariantPrice = activeOption.querySelector(
          "[data-rtx-subscription-price]",
        ).innerHTML;
      }

      mainButton.innerHTML = currentVariantPrice;
      theme.product.updateStickyPurchase(theme.product.variant);
    },
    getInvalidOptionSelectors: (currentVariant = theme.product.variant) => {
      let variants = theme.product.data.variants;
      let productOptions1 = [];
      let productOptions2 = [];
      let productOptions3 = [];
      let variantOptions2 = [];
      let variantOptions3 = [];
      let hideOptions2 = [];
      let hideOptions3 = [];
      let hiddenOptions = document.querySelectorAll(".option-hidden");

      variants.forEach((variant) => {
        if (variant.option1) {
          if (productOptions1.indexOf(variant.option1) === -1) {
            productOptions1.push(variant.option1);
          }
        }
        if (variant.option2) {
          if (productOptions2.indexOf(variant.option2) === -1) {
            productOptions2.push(variant.option2);
          }
        }
        if (variant.option3) {
          if (productOptions3.indexOf(variant.option3) === -1) {
            productOptions3.push(variant.option3);
          }
        }
      });
      variants.forEach((variant) => {
        if (variant.option1 === currentVariant.option1) {
          if (
            variant.option2 &&
            variantOptions2.indexOf(variant.option2) === -1
          ) {
            variantOptions2.push(variant.option2);
          }
          if (
            variant.option3 &&
            variantOptions3.indexOf(variant.option3) === -1
          ) {
            variantOptions3.push(variant.option3);
          }
        }
      });

      hideOptions2 = productOptions2.filter(
        (x) => !variantOptions2.includes(x),
      );
      hideOptions3 = productOptions3.filter(
        (x) => !variantOptions3.includes(x),
      );

      return { hideOptions2, hideOptions3 };
    },
    setValidOptionSelectors: (currentVariant = theme.product.variant) => {
      let variants = theme.product.data.variants;
      let productOptions1 = [];
      let productOptions2 = [];
      let productOptions3 = [];
      let variantOptions2 = [];
      let variantOptions3 = [];
      let hideOptions2 = [];
      let hideOptions3 = [];
      let hiddenOptions = document.querySelectorAll(".option-hidden");

      variants.forEach((variant) => {
        if (variant.option1) {
          if (productOptions1.indexOf(variant.option1) === -1) {
            productOptions1.push(variant.option1);
          }
        }
        if (variant.option2) {
          if (productOptions2.indexOf(variant.option2) === -1) {
            productOptions2.push(variant.option2);
          }
        }
        if (variant.option3) {
          if (productOptions3.indexOf(variant.option3) === -1) {
            productOptions3.push(variant.option3);
          }
        }
      });
      variants.forEach((variant) => {
        if (variant.option1 === currentVariant.option1) {
          if (
            variant.option2 &&
            variantOptions2.indexOf(variant.option2) === -1
          ) {
            variantOptions2.push(variant.option2);
          }
          if (
            variant.option3 &&
            variantOptions3.indexOf(variant.option3) === -1
          ) {
            variantOptions3.push(variant.option3);
          }
        }
      });

      hideOptions2 = productOptions2.filter(
        (x) => !variantOptions2.includes(x),
      );
      hideOptions3 = productOptions3.filter(
        (x) => !variantOptions3.includes(x),
      );

      // Reset Options
      if (hiddenOptions.length > 0) {
        hiddenOptions.forEach((option) => {
          option.classList.remove("option-hidden");
        });
      }

      // Hide Options
      hideOptions2.forEach((option) => {
        if (
          document.querySelector(
            `[data-product-option-2] [data-option-title="${option}"]`,
          )
        ) {
          document
            .querySelector(
              `[data-product-option-2] [data-option-title="${option}"]`,
            )
            .classList.add("option-hidden");
        }
      });

      hideOptions3.forEach((option) => {
        if (
          document.querySelector(
            `[data-product-option-3] [data-option-title="${option}"]`,
          )
        ) {
          document
            .querySelector(
              `[data-product-option-3] [data-option-title="${option}"]`,
            )
            .classList.add("option-hidden");
        }
      });
    },
    /*
  initProductVideo: () => {
    const wrapper = document.querySelector(".product-video");
    const playbackId = wrapper.dataset.id
    const title = wrapper.dataset.title


    import("@mux/mux-player").then(() => {
      const player = document.createElement("mux-player");

      player.setAttribute("stream-type", "on-demand");
      player.setAttribute("playback-id", playbackId);
      player.setAttribute("metadata-video-title", title);


    });

    window.productVideoWrapper = document.querySelector('.product-video');
    window.productVideoPlayer = document.createElement("mux-player");

    window.theme.productVideo = function () {
      window.productVideoWrapper = document.querySelector('.product-video');
      window.productVideoPlayer = document.createElement("mux-player");
      if (window.productVideoWrapper) {
        window.productVideoPlayer.setAttribute("stream-type", "on-demand");
        window.productVideoPlayer.setAttribute("playback-id", window.productVideoWrapper.dataset.id);
        window.productVideoPlayer.setAttribute("metadata-video-title", window.productVideoWrapper.dataset.title);
        window.productVideoWrapper.appendChild(window.productVideoPlayer);
        window.awaitMUX = setInterval(function () {
          if ('undefined' !== typeof MuxPlayerElement) {
            window.productVideoWrapper.appendChild(window.productVideoPlayer);
            setTimeout(function () {
              window.productVideoPlayer.play()
            }, 3000);
            clearInterval(window.awaitMUX);
          } else {
            setTimeout(function () {
              clearInterval(window.awaitMUX);
            }, 10000);
          }
        }, 10);
      }
    }
    window.theme.productVideo();
  },
  */
    updatePlansForVariant(variant = theme.product.variant) {
      if (!theme.product.isSubscriptionBoxVisible()) return;
      let newOptions = "";
      let currentPlanId = theme.product.getSellingPlanId();
      variant.selling_plan_allocations.forEach((spa, i) => {
        const sellingGroup = theme.product.data.selling_plan_groups.find(
          (spg) => spg.id === spa.selling_plan_group_id,
        );
        const sellingPlan = sellingGroup.selling_plans.find(
          (sp) => sp.id === spa.selling_plan_id,
        );
        const opt = document.createElement("option");
        opt.value = sellingPlan.id;
        opt.textContent = sellingPlan.name;
        if (sellingPlan.id == currentPlanId) {
          opt.setAttribute("selected", "selected");
        }
        newOptions += opt.outerHTML;
      });
      theme.product.sellingPlanSelector.innerHTML = newOptions;
      console.log(
        "======== updatePlansForVariant",
        theme.product.sellingPlanSelector.value,
      );
    },
    updateSubscriptionUI: (
      variant = theme.product.variant,
      scope = document,
    ) => {
      let subscriptionButton = scope.querySelector(
        ".subscription-button button",
      );
      let subscriptionBenefits = scope.querySelector(
        ".product-purchase__benefits",
      );
      let discountBadge = scope.querySelector(".discount-badge");
      if (variant.selling_plan_allocations.length > 0) {
        if (subscriptionButton) {
          subscriptionButton.disabled = false;
        }
        if (subscriptionBenefits) {
          subscriptionBenefits.classList.remove("disabled");
        }
        if (discountBadge) {
          discountBadge.classList.remove("disabled");
        }
      } else {
        if (subscriptionButton) {
          subscriptionButton.disabled = true;
        }
        if (subscriptionBenefits) {
          subscriptionBenefits.classList.add("disabled");
        }
        if (discountBadge) {
          discountBadge.classList.add("disabled");
        }
      }
    },
    updateBadgeUI: (variant = theme.product.variant, scope = document) => {
      let variantBadges = scope.querySelectorAll(".variant-badge");
      if (variantBadges) {
        variantBadges.forEach((badge) => {
          const badgeID = parseInt(badge.dataset.id);
          if (variant.id === badgeID) {
            badge.classList.remove("disabled");
            //console.log(`Badge ${badgeID} enabled. variant.id: ${variant.id}`);
          } else {
            badge.classList.add("disabled");
            //console.log(`Badge ${badgeID} disabled. variant.id: ${variant.id}`);
          }
        });
      }
    },
  };

  // Event Listeners
  theme.product.purchaseType.forEach((el) => {
    el.addEventListener("change", (e) => {
      if (el.value === "purchaseTypeSubscription") {
        theme.product.showSubscriptionBox();
      } else {
        theme.product.hideSubscriptionBox();
      }

      theme.product.updateMainButtonPrice();
    });
  });

  theme.product.variantSelectors.forEach((vs) => {
    vs.addEventListener("change", (e) => {
      let newOptions = "";
      theme.product.variantId = e.target.value;
      const variant = theme.product.data.variants.find(
        (v) => v.id == theme.product.variantId,
      );

      // Determine the selected option
      let selectedPlanId = theme.product.getSellingPlanId();
      if (
        !variant.selling_plan_allocations.some((spa) => {
          return spa.selling_plan_id == selectedPlanId;
        })
      ) {
        if (variant.selling_plan_allocations.length) {
          selectedPlanId = variant.selling_plan_allocations[0].selling_plan_id;
        } else {
          selectedPlanId = "";
        }
      }
      // Generate new options
      variant.selling_plan_allocations.forEach((spa, i) => {
        const sellingGroup = boxProduct.selling_plan_groups.find(
          (spg) => spg.id === spa.selling_plan_group_id,
        );
        const sellingPlan = sellingGroup.selling_plans.find(
          (sp) => sp.id === spa.selling_plan_id,
        );
        if (sellingGroup.app_id != RETEXTION_APP_ID) return;
        const opt = document.createElement("option");
        if (sellingPlan.id == selectedPlanId) {
          opt.setAttribute("selected", "selected");
        }
        opt.value = sellingPlan.id;
        opt.textContent = sellingPlan.name;
        newOptions += opt.outerHTML;
      });

      // Update select
      elementSellingPlan.innerHTML = newOptions;
      theme.product.updateSellingPlan();
    });
  });

  document.body.addEventListener("variantChange", (e) => {
    theme.product.setCurrentVariantLabel(theme.product.variant);
    theme.product.updateSellingPlan();
    theme.product.updateMainButtonPrice();
    theme.product.updateVariantSelector(theme.product.variant.id);
    theme.product.updateStockStatus(theme.product.variant);
    theme.product.updateSubscriptionUI(theme.product.variant);
    theme.product.updateBadgeUI(theme.product.variant);
    //window.theme.productVideo();
    if (theme.product.variant.title !== "Default Title") {
      theme.product.setCurrentVariantMedia(theme.product.variant);
      theme.product.setValidOptionSelectors(theme.product.variant);
    }
    console.log(`variant changed: ${theme.product.variant.title}`);
  });

  document.body.addEventListener("click", (e) => {
    if (!e.target.matches("#purchaseTypeOneTime")) return;
  });

  document.body.addEventListener("click", (e) => {
    if (!e.target.matches("#purchaseTypeSubscription")) return;
    const sellingPlanCount = document.querySelectorAll(
      ".rtx-subscription-dropdown option",
    ).length;
    theme.product.updateSellingPlan();
    if (sellingPlanCount !== 2) {
      document.querySelector(".rtx-subscription-dropdown").value = "";
      setTimeout(() => {
        document
          .querySelector(".product-purchase")
          .classList.add("select-frequency");
      }, 200);
    } else {
      document.querySelector(
        ".rtx-subscription-dropdown option:last-child",
      ).selected = true;
    }
  });

  document.body.addEventListener("click", (e) => {
    if (!e.target.matches(".product-options .radio input")) return;
    theme.product.updateCurrentVariant();
  });
  document.body.addEventListener("change", (e) => {
    if (!e.target.matches(".rtx-subscription-dropdown")) return;
    const sellingPlanId = e.target.value;
    window.retextionApi?.sellingPlanPushHistory({
      sellingPlan: sellingPlanId,
    });
    // theme.product.subscribeButton.click();
    // document.querySelector('.product-purchase').classList.remove('select-frequency');
    // document.querySelector('.rtx-subscription-dropdown').value = ''
  });

  if (document.querySelector(".js-usage")) {
    document.querySelectorAll(".js-usage details").forEach((details) => {
      details.addEventListener("toggle", (e) => {
        if (details.open) {
          setTimeout(() => {
            details
              .querySelectorAll(".accordion__content mux-player")
              .forEach(function (video) {
                let awaitMUX = setInterval(function () {
                  if ("undefined" !== typeof MuxPlayerElement) {
                    video.play();
                    clearInterval(awaitMUX);
                  } else {
                    setTimeout(function () {
                      clearInterval(awaitMUX);
                    }, 10000);
                  }
                }, 200);
              });
          }, 100);
        }
      });
    });
  }

  window.addEventListener("load", function () {
    let awaitMUX = setInterval(function () {
      if ("undefined" !== typeof MuxPlayerElement) {
        setTimeout(function () {
          document.querySelector(".product-video mux-player").play();
        }, 3000);
        clearInterval(awaitMUX);
      } else {
        setTimeout(function () {
          clearInterval(awaitMUX);
        }, 10000);
      }
    }, 200);
  });

  theme.product.init();
})();
